import React from "react";
import "./Home.css";

const BookaCall = () => {
  return (
    <div  className="cta-wrapper">
    <section className="backdiv">

    
        <h2 className="main-title">
          Let’s Build Something Future-Ready
        </h2>

        <p className="main-text text-center">
          Transform your business with cutting-edge AI, scalable systems, and
          high-converting digital experiences.
        </p>

        <div className="cta-buttons">
          <button className="book-btn">
            <a href="/contact-us">
            Book a Call</a>
          </button>

          <button className="book-btn">
             <a href="/contact-us">
            Get Proposal</a>
          </button>
        </div>
    
    </section>
    </div>
  );
};

export default BookaCall;